import { render, staticRenderFns } from "./cultivation.vue?vue&type=template&id=2e405d06&scoped=true&"
import script from "./cultivation.vue?vue&type=script&lang=js&"
export * from "./cultivation.vue?vue&type=script&lang=js&"
import style0 from "./cultivation.vue?vue&type=style&index=0&id=2e405d06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e405d06",
  null
  
)

export default component.exports